// extracted by mini-css-extract-plugin
export const profile = "profile-module--profile--8GsG3";
export const image = "profile-module--image--2WToq";
export const left = "profile-module--left--20si6";
export const right = "profile-module--right--rAY5n";
export const name = "profile-module--name--35Hbs";
export const description = "profile-module--description--33-nP";